// Copyright (C) 2021 Bystronic Laser AG

export class CustomerCutConfig {
  constructor(
    public id: number,
    public channel0Name: string,
    public channel1Name: string,
    public channel2Name: string,
    public channel3Name: string,
  ) {}
}
